import { useEffect } from "react";

export const NAVER_TRAFFIC_SOURCE_KEY = "STOREFRONT_NAVER_AD_SOURCE";
export const NAVER_CAMPAIGN_ID_KEY = "STOREFRONT_NAVER_CAMPAIGN_ID";

export function getStoredNaverTrafficSource(): "naver_shopping" | "naver_paid_shopping" | null {
  return sessionStorage.getItem(NAVER_TRAFFIC_SOURCE_KEY) as "naver_shopping" | "naver_paid_shopping" | null;
}

export function getStoredNaverCampaignId(): string | null {
  return sessionStorage.getItem(NAVER_CAMPAIGN_ID_KEY);
}

// n_ad 파라미터가 있거나 utm_medium=paid_shopping일 때 네이버쇼핑검색광고, utm_medium=shopping일 때 네이버쇼핑(오가닉)으로 판별.
// campaign id는 utm_campaign이 쇼핑피드 기본값(always_on)이 아닐 때만 저장한다.
export default function useNaverTrafficSource(search: string): void {
  useEffect(() => {
    const params = new URLSearchParams(search);
    const utmSource = params.get("utm_source");
    const utmMedium = params.get("utm_medium");

    const isPaidShopping = utmSource === "naver" && (params.has("n_ad") || Boolean(utmMedium?.includes("paid")));
    const isOrganicShopping = utmSource === "naver" && utmMedium === "shopping";

    if (isPaidShopping) {
      sessionStorage.setItem(NAVER_TRAFFIC_SOURCE_KEY, "naver_paid_shopping");
      const utmCampaign = params.get("utm_campaign");
      const campaignId = utmCampaign && utmCampaign !== "always_on" ? utmCampaign : null;
      if (campaignId) sessionStorage.setItem(NAVER_CAMPAIGN_ID_KEY, campaignId);
    } else if (isOrganicShopping) {
      sessionStorage.setItem(NAVER_TRAFFIC_SOURCE_KEY, "naver_shopping");
    }
  }, [search]);
}
